module.exports = __webpack_public_path__ + "img/3.49b89143.png";